export default __webpack_public_path__ + "static/media/vectorHelp.b74d5e0e.svg";